import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, registrationType) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/RegistrationTypes`, method: 'POST', body: registrationType, token: token })
}
